import React from "react";

export default function SucessfullySubmited({
  handleSucessfulyfalse,
  refreshPage,
}) {
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/HwImg/sucessIcon.png" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
          You have successfully completed the Assessment
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2 sucessMsg2">
          Once teacher vaildated you will be notified
        </div>
        <div className="d-flex justify-content-center align-items-center mt-3">
          <button
            className="okayBtnsucess"
            onClick={() => {
              refreshPage();
              handleSucessfulyfalse();
              window.close();
              // window.location.replace('/Assessment');
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
